@if (allEntries) {
  <iim-card [header]="titleHeader" [footer]="footer">
    <ng-template #titleHeader>
      <div class="col">
        <div class="row">
          <div class="col">
            <h3>
              <em class="fas fa-clock-rotate-left pe-2"></em>
              {{ 'Historie' | translate }}
            </h3>
          </div>
        </div>
      </div>
    </ng-template>
    <activity-display [activities]="allEntries"></activity-display>
    <ng-template #footer>
      <div class="px-3">
        <div class="row">
          <div class="col">
            <div class="input-group">
              <textarea class="form-control" [formControl]="commentControl"></textarea>
              <span (click)="saveComment()" class="input-group-text cursor-pointer hoverable btn-secondary">
                <em class="fas fa-floppy-disk"></em>
              </span>
            </div>
          </div>
        </div>
      </div>
    </ng-template>
  </iim-card>
}
